import React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { ParsedPhoneNumber } from '../../../../../utils/phoneNumber'
import { PeopleBlock } from '../../blocksState'
import { PeopleBlockLayout } from './peopleBlockLayout'
import { PeopleBlockState } from './peopleBlockState'

export const peopleBlockWidget = (block: PeopleBlock): Widget<Updater<PeopleBlockState>> =>
  async<Map<number, ParsedPhoneNumber>>(block.peopleBlockState, phoneNumbersMap =>
    fromJSX(() => (
      <PeopleBlockLayout
        title={block.title}
        link={block.link}
        index={block.index}
        people={block.people.map((person) => ({
          ...person,
          phoneNumber: phoneNumbersMap.get(person.phoneNumberId),
        }))}
        imageOptions={block.imageOptions}
      />
    ))
  )
